import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter, Button } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedDate } from "react-intl";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";

import styles from "./styles.module.scss";
import { CustomFormInput, FormField } from "../../utils/FormFields";
import { localDateTime } from "../../utils/Helper";

const ModalSpotQuote = ({ quote, handleClose, open, handleSave, loading }) => {
  const [newPrice, setNewPrice] = useState(parseFloat(quote.PairPricePrice));

  const handleChangePrice = (name, value) => {
    setNewPrice(value);
  };

  const handleSubmit = () => {
    const newPairPrice = {
      ...quote,
      PairPriceDate: new Date().toISOString().substr(0, 23),
      PairPricePrice: newPrice,
    };
    handleSave(newPairPrice);
  };

  const handlePreClose = () => {
    if (!loading) {
      handleClose();
    }
  };

  return (
    <Modal isOpen={open} className={styles.modal}>
      <ModalHeader toggle={handlePreClose}>
        Edit Spot Quote
        <div className="valid-feedback" style={{ display: "block", color: "gray" }}>
          {quote.PairPriceDescription}
          {" - Last Edited: "}
          <FormattedDate value={`${quote.PairPriceDate}Z`} />
          {` - ${localDateTime(quote.PairPriceDate).toTimeString().substr(0, 5)}`}
        </div>
      </ModalHeader>
      <ModalBody className={styles.body}>
        <Row>
          <Col>
            <CustomFormInput
              label={quote.PairPriceDescription.substr(0, quote.PairPriceDescription.indexOf("/"))}
            >
              1
            </CustomFormInput>
          </Col>
          <Col>
            <FormField
              label={quote.PairPriceDescription.substr(
                quote.PairPriceDescription.indexOf("/") + 1,
                quote.PairPriceDescription.length
              )}
              value={newPrice}
              onChange={handleChangePrice}
              name=""
              type="number"
              dataTypeDecimalName="price"
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button disabled={loading} color="light" onClick={handleClose}>
          Close
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loading}
          onClick={handleSubmit}
          data-style={EXPAND_RIGHT}
        >
          {loading ? "Saving..." : "Save"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

ModalSpotQuote.propTypes = {
  quote: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ModalSpotQuote;
